import { addHeaderAndFooter } from "./addHeaderAndFooter";

export async function applyHeaderAndFooter(doc, offset, uid) {
  var pageNumber = 0;
  //Add header and footer to each page
  var pageInfo = doc.internal.getCurrentPageInfo();
  var totalPages = pageInfo.pageNumber;

  for (var z = 1; z <= totalPages; z++) {
    doc.setPage(z);
    await addHeaderAndFooter(doc, offset, uid);
    pageNumber = z;
  }

  return pageNumber;
}
